import { LabelValueOption } from "@/types";
import { useCallback, useMemo } from "react";

export enum SupportedCountries {
  US = "US",
  CA = "Canada",
  GB = "United Kingdom",
  AU = "Australia"
}

export const generateArrayOfCountryOptions = (): LabelValueOption[] => {
  return Object.entries(SupportedCountries).map(([code, name]) => ({
    value: code as keyof typeof SupportedCountries,
    label: name,
  }));
}

const generateArrayOfUSStateOptions = (): LabelValueOption[] => {
  return [
    { value: "AK", label: "Alaska" },
    { value: "AL", label: "Alabama" },
    { value: "AR", label: "Arkansas" },
    { value: "AS", label: "American Samoa" },
    { value: "AZ", label: "Arizona" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DC", label: "District of Columbia" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "GU", label: "Guam" },
    { value: "HI", label: "Hawaii" },
    { value: "IA", label: "Iowa" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "MA", label: "Massachusetts" },
    { value: "MD", label: "Maryland" },
    { value: "ME", label: "Maine" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MO", label: "Missouri" },
    { value: "MS", label: "Mississippi" },
    { value: "MT", label: "Montana" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "NE", label: "Nebraska" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NV", label: "Nevada" },
    { value: "NY", label: "New York" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "PR", label: "Puerto Rico" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VA", label: "Virginia" },
    { value: "VI", label: "Virgin Islands" },
    { value: "VT", label: "Vermont" },
    { value: "WA", label: "Washington" },
    { value: "WI", label: "Wisconsin" },
    { value: "WV", label: "West Virginia" },
    { value: "WY", label: "Wyoming" }
  ];
}

const generateArrayOfCanadaProvinceOptions = (): LabelValueOption[] => {
  return [
    { value: "AB", label: "Alberta" },
    { value: "BC", label: "British Columbia" },
    { value: "MB", label: "Manitoba" },
    { value: "NB", label: "New Brunswick" },
    { value: "NL", label: "Newfoundland and Labrador" },
    { value: "NS", label: "Nova Scotia" },
    { value: "NT", label: "Northwest Territories" },
    { value: "NU", label: "Nunavut" },
    { value: "ON", label: "Ontario" },
    { value: "PE", label: "Prince Edward Island" },
    { value: "QC", label: "Quebec" },
    { value: "SK", label: "Saskatchewan" },
    { value: "YT", label: "Yukon" }
  ];
}

const generateArrayOfAustralianStates = (): LabelValueOption[] => {
  return [
    { value: "ACT", label: "Australian Capital Territory" },
    { value: "NSW", label: "New South Wales" },
    { value: "NT", label: "Northern Territory" },
    { value: "QLD", label: "Queensland" },
    { value: "SA", label: "South Australia" },
    { value: "TAS", label: "Tasmania" },
    { value: "VIC", label: "Victoria" },
    { value: "WA", label: "Western Australia" },
  ];
}

export const useStateList = (country?: string) => {

  const getStateLists = useCallback((country: SupportedCountries): LabelValueOption[] => {
    switch (country) {
      case SupportedCountries.GB: return [];
      case SupportedCountries.CA: return generateArrayOfCanadaProvinceOptions();
      case SupportedCountries.US: return generateArrayOfUSStateOptions();
      case SupportedCountries.AU: return generateArrayOfAustralianStates();
    }
  }, [])

  const stateListOptions = useMemo((): LabelValueOption[] => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const supoortedCountry = country ? (SupportedCountries as any)[country] : undefined;
    return supoortedCountry ? getStateLists(supoortedCountry) : []
  }, [country, getStateLists]);
  
  return {
    stateListOptions
  }
}